import * as am4core from "@amcharts/amcharts4/core";

import * as _ from "lodash"


export const SeriesColor = class {
    static DEFAULT_COLOR = am4core.color("#3d81f7")

    static SERIES_COLORS = [
        // Default Sonicu Blue
        am4core.color("#3d81f7"),

        // Chartreuse / Lime-Green
        am4core.color("#7fff00"),

        // Teal-Green
        am4core.color("#30d5c8"),

        // Plum-Purple
        am4core.color("#3d1a39"),

        // Carrot-Orange
        am4core.color("#fd6a02"),

        // Cinnamon
        am4core.color("#7b3f00"),

        // Crimson Red
        am4core.color("#dc143c"),

        // Forest Green
        am4core.color("#228b22"),

        // Gold
        am4core.color("#ffd700"),

        // Deep Pink
        am4core.color("#ff1493"),

        // Royal Blue
        am4core.color("#4169e1"),

        // Orange Red
        am4core.color("#ff4500"),

        // Medium Purple
        am4core.color("#9370db"),

        // Dark Turquoise
        am4core.color("#00ced1"),

        // Chocolate
        am4core.color("#d2691e"),

        // Lime
        am4core.color("#32cd32"),

        // Hot Pink
        am4core.color("#ff69b4"),

        // Steel Blue
        am4core.color("#4682b4"),

        // Dark Orange
        am4core.color("#ff8c00"),

        // Medium Sea Green
        am4core.color("#3cb371"),
    ]

    static usedColors = []
    static availableColors = []

    static currentColorIndex = 0

    /**
     * Return a boolean; true if there is another color & false otherwise.
     */
    static hasNextColor() {
        return SeriesColor.availableColors.length > 0
    }

    /**
     * Return the next am4 color for the system to use.
     * Null if there is now next color
     */
    static peekNextColor() {
        if (!SeriesColor.hasNextColor()) {
            return false
        }

        let lastIndex = SeriesColor.availableColors.length - 1
        return SeriesColor.SERIES_COLORS[SeriesColor.availableColors[lastIndex]]
    }

    /**
     * Advance the current color to the next one and return the new color
     */
    static nextColor() {
        if (!SeriesColor.hasNextColor()) {
            return SeriesColor.DEFAULT_COLOR
        }

        let colorIndex = SeriesColor.availableColors.pop()
        SeriesColor.usedColors.push(colorIndex)

        return SeriesColor.SERIES_COLORS[colorIndex]
    }

    static resetColors() {
        let colorsIndexes = _.range(SeriesColor.SERIES_COLORS.length)
        SeriesColor.availableColors = colorsIndexes.reverse()
    }

    static releaseColor(color) {
        let colorIndex = SeriesColor.getIndexFromColor(color)
        console.log(`Releasing Color: ${colorIndex}`)

        SeriesColor.availableColors.push(colorIndex)
        let usedIndex = SeriesColor.usedColors.indexOf(colorIndex)
        if (usedIndex !== -1) {
            SeriesColor.usedColors.splice(usedIndex, 1)
        }
    }

    /**
     * Get a color from a particualar index in cases that a client class stores a color index
     * Null if the index is not found
     */
    static getColorFromIndex(index = null) {
        let currentIndex = _.isNil(index) ? SeriesColor.currentColorIndex : index

        return currentIndex < SeriesColor.SERIES_COLORS.length
                ? SeriesColor.SERIES_COLORS[SeriesColor.currentColorIndex]
                : null
    }

    /**
     * Get the index in the Series List of the next color
     * Null if the color is not found
     */
    static getIndexFromColor(color) {
        let index = SeriesColor.SERIES_COLORS.indexOf(color)

        return index === -1
            ? null
            : index
    }
}